import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import {
  buildTicketCenterSrc,
  buildTicketReplySrc,
  fetchCrispSession,
} from "../hooks/useCrispSession";

const supportNotConfiguredMessage =
  "The support system is not configured properly.";

const CrispTicketPanel = ({ open, onClose, ticketId = null, fullScreen = false }) => {
  const [ticketSrc, setTicketSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      setTicketSrc(null);
      setError(null);
      return;
    }

    setLoading(true);
    fetchCrispSession()
      .then((session) => {
        setTicketSrc(
          ticketId
            ? buildTicketReplySrc(session, ticketId)
            : buildTicketCenterSrc(session)
        );
        setError(null);
      })
      .catch(() => {
        setTicketSrc(null);
        setError(supportNotConfiguredMessage);
      })
      .finally(() => setLoading(false));
  }, [open, ticketId]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Support tickets
        <IconButton
          aria-label="close support tickets"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress size={32} />
          </Box>
        ) : error || !ticketSrc ? (
          <Box sx={{ p: 3 }}>
            <Typography color="text.secondary">
              {error || supportNotConfiguredMessage}
            </Typography>
          </Box>
        ) : (
          <Box sx={{ height: fullScreen ? "calc(100vh - 120px)" : "600px" }}>
            <iframe
              title="ticket-center"
              src={ticketSrc}
              referrerPolicy="origin"
              sandbox="allow-forms allow-popups allow-modals allow-downloads allow-scripts allow-same-origin"
              width="100%"
              height="100%"
              frameBorder="0"
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CrispTicketPanel;
